import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { RootState } from "../../store"
import { v4 as uuidv4 } from "uuid"
import {
  ALERT_MSGS,
  ALERT_STATUS_MSGS,
  API_STATUS,
  CLUSTER_OPTIONS,
  colorMapperGant,
  DEEP_DIVE_DATA,
  defaultPipelineData,
  MONITOR_CARDS,
  monthOptions,
  MONTHS,
  PIPELINE_RESPONSE_STATIC,
  textMapperGant,
  viewMorePipelineData,
} from "../../util/StaticData"
import {
  parseISO,
  format,
  differenceInMilliseconds,
  intervalToDuration,
  formatDuration,
  getMonth,
  getYear,
} from "date-fns"
import {
  IMonitorCardInterface,
  PipelineStatusCodes,
  IWorkflow,
  IClusterMemoryChartData,
  Screen,
  IPipelineData,
  IDeepDiveData,
  INewTableCellChangePayload,
  IParameter,
  ITask,
  IAlertStatus,
} from "../../util/interface"
import {
  CreateDropDownOptions,
  pipelineConfigMapping,
} from "../../util/CommonMethods"
import AxiosOperations from "../../services/AxiosOperations"
import { API } from "../../util/api"
import dayjs from "dayjs"
import { usePapaParse } from "react-papaparse"
import { AlertColor } from "@mui/material"
import {
  NEW_PIPELINE_SCREENS,
  newPipeLineMapper,
  NewPipeLineTabs,
} from "../../util/NewPipelineConfig"

const clusterMemoryChartData: IClusterMemoryChartData = {
  clusterMemory: [],
  clusterCached: [],
  clusterShared: [],
  clusterLoad: [],
  loadProcs: [],
  loadCpus: [],
}
const resultObject: any = {}

NewPipeLineTabs.forEach((item) => {
  resultObject[item.key] = {}
})
const flowDiagramData: any = []
const gantData: any = []
const deepDiveActiveScreen:
  | Screen.Default
  | Screen.MoreDetails
  | Screen.ViewMore = Screen.Default
const deepDiveRawData: IDeepDiveData = DEEP_DIVE_DATA
const deepDiveData: any = defaultPipelineData
const usageMonitoringLabels: any = {}
const activeGantSelection: any = {}
const selectedRunDetails = {}

const pipelineRunDialog: any = {
  isOpen: false,
  data: [],
  selectedRunDetails,
}
const newPipeLine: any = {
  tabIndex: "RAW Config & Quality Config",
  tableData: {
    "RAW Config & Quality Config": [],
    "UDM Config": [],
    "ADM Config": [],
    "RDQ Config": [],
    "Input Series Config": [],
    "RAW Data Drift Config": [],
    "Flexible Schema Config": [],
    "Model Config": [],
  },
  activeData: [],
  status: API_STATUS.IDLE,
  filters: {
    market: {
      status: API_STATUS.IDLE,
      selectedValue: "",
      filterOptions: [],
    },
    pipeline: {
      status: API_STATUS.IDLE,
      selectedValue: "",
      filterOptions: [],
    },
    useCase: {
      status: API_STATUS.IDLE,
      selectedValue: "",
      filterOptions: [],
    },
  },
  refreshInprogress: false,
  activeScreen: NEW_PIPELINE_SCREENS.DETAILS,
  runNow: true,
  scheduleNow: false,
  scheduelPipeLineStatus: API_STATUS.IDLE,
  runPipeLineStatus: API_STATUS.IDLE,
  schedule: {
    timeZone: "",
    time: null,
    date: new Date().toISOString(),
  },
  isParameterOrconfig: "Config",
  userChangedTabs: [],
}
const alertStatus: IAlertStatus = {
  msg: "",
  status: "info",
  open: false,
}
const rawFlowDiagramData: any = []
export const initialState = {
  cards: MONITOR_CARDS,
  gantChartData: gantData,
  lastRunDate: "",
  status: API_STATUS.IDLE,
  gantChartStatus: API_STATUS.IDLE,
  lastRunStatus: API_STATUS.IDLE,
  cardsStatus: API_STATUS.IDLE,
  isModalOpen: false,
  clusterMemoryChartData,
  clusterMemoryChartStatus: API_STATUS.IDLE,
  activeClusterOption: CLUSTER_OPTIONS.LOAD,
  refreshStatus: API_STATUS.IDLE,
  activeGantSelection,
  flowDiagramData: flowDiagramData,
  flowDiagramStatus: API_STATUS.IDLE,
  rawFlowDiagramData,
  selectedParentNode: "",
  newPipeLineConfig: resultObject,
  deepDiveRawData: deepDiveRawData,
  deepDiveDataStatus: API_STATUS.IDLE,
  deepDiveActiveScreen: deepDiveActiveScreen,
  deepDiveData,
  usageMonitoringLabels,
  activeGantSelectionLabel: "",
  newPipeLine,
  flowDiagramADFLink: "",
  pipelineRunDialog,
  alertStatus,
  activeCard: "pipelines",
  rawGantChartData: gantData,
  monthSelectedValue: monthOptions[getMonth(new Date())].value,
  yearSelectedValue: `${getYear(new Date())}`,
  parameterConfigData: [],
}
export const monitorUseCaseFilterOptionsAsync = createAsyncThunk(
  "monitor/useCaseOptions",
  async () => {
    try {
      const payload = {
        is_parent: true,
      }
      const axiosObj = new AxiosOperations()
      return axiosObj.get(API.USECASE_OPTIONS, payload)
    } catch (error) {
      console.error("Error:", error)
    }
  },
)
export const marketSingleFilterOptionsAsync = createAsyncThunk(
  "monitor/marketSingleOptions",
  async () => {
    try {
      const payload = {
        is_parent: true,
      }
      const axiosObj = new AxiosOperations()
      return axiosObj.get(API.MARKET_FILTER, payload)
    } catch (error) {
      console.error("Error:", error)
    }
  },
)

export const schedulePipeLineAsync = createAsyncThunk(
  "monitor/schedulePipeLine",
  async (_, { getState }) => {
    try {
      const state: any = getState()
      const pipeline = state.monitor.newPipeLine.filters.pipeline.selectedValue
      let time = state.monitor.newPipeLine.schedule.time
      const date = state.monitor.newPipeLine.schedule.date
      const timezone = state.monitor.newPipeLine.schedule.timeZone
      time = dayjs(time).format("HH:mm")
      const payload = {
        time: time,
        pipeline: pipeline,
        date: dayjs(date).format("YYYY-MM-DD"),
        timezone: timezone,
      }
      const axiosObj = new AxiosOperations()
      return axiosObj.get(API.SCHEDULE_PIPLINE, payload)
    } catch (error) {
      console.error("Error:", error)
    }
  },
)

export const runPipeLineAsync = createAsyncThunk(
  "monitor/runPipeLine",
  async (_, { getState }) => {
    try {
      const state: any = getState()
      const payload = {
        pipeline_name: state.monitor.newPipeLine.filters.pipeline.selectedValue,
      }
      const axiosObj = new AxiosOperations()
      return axiosObj.get(API.RUN_PIPELINE, payload)
    } catch (error) {
      console.error("Error:", error)
    }
  },
)
export const pipelineFilterOptionsAsync = createAsyncThunk(
  "monitor/pipeline-names-list",
  async () => {
    try {
      const axiosObj = new AxiosOperations()
      return axiosObj.get(API.PIPELINE_NAMES_LIST)
    } catch (error) {
      console.error("Error:", error)
    }
  },
)
export const gantChartAsync = createAsyncThunk(
  "monitor/gantChart",
  async (_, { getState }) => {
    try {
      const state: any = getState()

      const payload = {
        use_case: state.filters.useCaseSelectedValue,
        marketplace: state.filters.marketSingleCaseSelectedValue,
        is_parent: true,
        year: Number(state.filters.yearSelectedValue),
        month: state.filters.monthSelectedValue,
      }
      const axiosObj = new AxiosOperations()
      return axiosObj.post(API.CALENDAR_REFRESH_DATA, payload)
    } catch (error) {
      console.error(error)
    }
  },
)

export const flowDiagramAsync = createAsyncThunk(
  "monitor/flowDiagramV2",
  async (
    { reference_pipeline }: { reference_pipeline: string },
    { getState },
  ) => {
    try {
      const state: any = getState()
      const run_id = state.monitor.pipelineRunDialog.selectedRunDetails.id
      const start_time =
        state.monitor.pipelineRunDialog.selectedRunDetails.start_time
      const end_time =
        state.monitor.pipelineRunDialog.selectedRunDetails.end_time
      const payload: any = {
        run_id,
        start_time,
        end_time,
      }
      if (reference_pipeline.length) {
        delete payload.run_id
        payload["reference_pipeline"] = reference_pipeline
      }

      const axiosObj = new AxiosOperations()
      return axiosObj.get(API.FLOW_DIAGRAM_V2, payload)
    } catch (error) {
      console.error(error)
    }
  },
)

export const lastRunAsync = createAsyncThunk(
  "monitor/lastRunDate",
  async () => {
    try {
      const axiosObj = new AxiosOperations()
      return axiosObj.get(API.LAST_RUN_DATE)
    } catch (error) {
      console.error("Error:", error)
    }
  },
)
export const lastRunAsynclastRunDateToCheckRefreshStatusAsync =
  createAsyncThunk("monitor/lastRunDateToCheckRefreshStatus", async () => {
    try {
      const axiosObj = new AxiosOperations()
      return axiosObj.get(API.LAST_RUN_DATE)
    } catch (error) {
      console.error("Error:", error)
    }
  })

export const pipelineCardsAsync = createAsyncThunk(
  "monitor/cards",
  async (_, { getState }) => {
    const state: any = getState()
    try {
      const payload = {
        use_case: state.filters.useCaseSelectedValue,
        marketplace: state.filters.marketSingleCaseSelectedValue,
        is_parent: true,
        year: state.filters.yearSelectedValue,
        month: state.filters.monthSelectedValue,
      }
      const axiosObj = new AxiosOperations()
      return axiosObj.get(API.PIPELINE_LIST, payload)
    } catch (error) {
      console.error("Error:", error)
    }
  },
)

export const deepDiveAsync = createAsyncThunk(
  "monitor/deep-div-data",
  async ({ pipeLineName, id }: { pipeLineName: string; id: number }) => {
    try {
      const payload = {
        pipeline_name: pipeLineName,
        run_id: id,
      }
      const axiosObj = new AxiosOperations()
      return axiosObj.get(API.DEEP_DIVE, payload)
    } catch (error) {
      console.error("Error:", error)
    }
  },
)

export const refreshStatusPipeLineAsync = createAsyncThunk(
  "monitor/refresh-pipeline",
  async () => {
    try {
      const axiosObj = new AxiosOperations()
      return axiosObj.get(API.REFRESH_STATUS)
    } catch (error) {
      console.error("Error:", error)
    }
  },
)

export const refreshPipeLineAsync = createAsyncThunk(
  "monitor/refresh-pipeline",
  async () => {
    try {
      const axiosObj = new AxiosOperations()
      return axiosObj.get(API.REFRESH)
    } catch (error) {
      console.error("Error:", error)
    }
  },
)

export const newPipeLineBaseDataAsync = createAsyncThunk(
  "monitor/new-pipeline-base-data",
  async (_, { getState }) => {
    try {
      const state: any = getState()
      const axiosObj = new AxiosOperations()
      const payload = {
        config_type: newPipeLineMapper[state.monitor.newPipeLine.tabIndex],
        usecase: state.monitor.newPipeLine.filters.useCase.selectedValue,
      }
      return axiosObj.get(API.NEW_PIPELINE_CONFIG, payload)
    } catch (error) {
      console.error("Error:", error)
    }
  },
)

export const newPipeLineUpdateBaseDataAsync = createAsyncThunk(
  "monitor/new-pipeline-update-base-data",
  async ({ data, fileType }: any, { getState }) => {
    try {
      const { jsonToCSV } = usePapaParse()

      const state: any = getState()
      const axiosObj = new AxiosOperations()
      const csv = jsonToCSV(data)
      const payload = {
        data: csv,
        file_type: fileType,
        usecase: state.monitor.newPipeLine.filters.useCase.selectedValue,
      }
      return axiosObj.post(API.UPDATE_NEWPIPELINE_CONFIG, payload)
    } catch (error) {
      console.error("Error:", error)
    }
  },
)

export const getParametersForPipelineAsync = createAsyncThunk(
  "monitor/get-pipeline-parameters",
  async ({ pipeline_name }: any) => {
    try {
      const axiosObj = new AxiosOperations()
      const payload = {
        pipeline_name,
      }
      return axiosObj.post(API.GET_PARAMETERS_FOR_PIPELINE, payload)
    } catch (error) {
      console.error("Error:", error)
    }
  },
)

export const updateParametersForPipelineAsync = createAsyncThunk(
  "monitor/update-pipeline-parameters",
  async (payload: any) => {
    try {
      const axiosObj = new AxiosOperations()
      return axiosObj.post(API.UPDATE_PARAMETERS_FOR_PIPELINE, payload)
    } catch (error) {
      console.error("Error:", error)
    }
  },
)

export const monitorSlice = createSlice({
  name: "monitor",
  initialState,
  reducers: {
    updateRefreshStatus: (state, action: PayloadAction<boolean>) => {
      state.newPipeLine.refreshInprogress = action.payload
    },
    monthFilterChangeMonitor: (state, action: PayloadAction<string>) => {
      state.monthSelectedValue = action.payload
    },
    yearFilterChangeMonitor: (state, action: PayloadAction<string>) => {
      state.yearSelectedValue = action.payload
    },
    cardToggle: (state, action: PayloadAction<string>) => {
      state.activeCard = action.payload
    },
    openPipeLineRunDialog: (state) => {
      state.pipelineRunDialog.isOpen = true
    },
    closePipeLineRunDialog: (state) => {
      state.pipelineRunDialog.isOpen = false
    },
    setPipeLineRunDialogData: (state, action: PayloadAction<any>) => {
      state.pipelineRunDialog.data = action.payload
    },
    setRunDetails: (state, action: PayloadAction<any>) => {
      state.pipelineRunDialog.selectedRunDetails = action.payload
    },
    openDialog: (state) => {
      state.isModalOpen = true
    },
    closeDialog: (state) => {
      state.isModalOpen = false
    },
    setAlertData2: (state, action: PayloadAction<IAlertStatus>) => {
      state.alertStatus = action.payload
    },
    clusterOptionOnChange: (state, action: PayloadAction<string>) => {
      state.activeClusterOption = action.payload as CLUSTER_OPTIONS
    },
    gantSelectionChange: (state, action: PayloadAction<any>) => {
      state.activeGantSelection = action.payload
    },
    updateGantSelectionLabel: (state, action: PayloadAction<string>) => {
      state.activeGantSelectionLabel = action.payload
    },
    setFlowDiagramData: (state, action: PayloadAction<any>) => {
      state.flowDiagramData = action.payload
    },
    setParentNode: (state, action: PayloadAction<any>) => {
      state.selectedParentNode = action.payload
    },
    updateFlowDiagram: (state, action: PayloadAction<string>) => {
      const temp = state.rawFlowDiagramData.filter((obj: any) => {
        return obj["pipeline"]["name"] === action.payload
      })
      const newData = temp.find(
        (obj: any) =>
          obj.az_pipeline_run_id ===
          state.pipelineRunDialog.selectedRunDetails.az_pipeline_run_id,
      )
      if (newData) {
        state.flowDiagramADFLink = newData["az_pipeline_run_url"]
        state.flowDiagramData = flowDiagramMapping([newData])
      } else {
        state.flowDiagramData = []
      }
    },
    deepDiveScreenChange: (state, action: PayloadAction<any>) => {
      state.deepDiveActiveScreen = action.payload
      if (state.deepDiveActiveScreen === Screen.Default) {
        state.deepDiveData = commonDeepDiveMapper(state, defaultPipelineData)
      } else if (state.deepDiveActiveScreen === Screen.ViewMore) {
        state.deepDiveData = commonDeepDiveMapper(state, viewMorePipelineData)
      } else {
        const deepDiveRawData: any = state.deepDiveRawData
        const parameters: any = deepDiveRawData?.data?.["parameters"].map(
          (obj: any) => {
            obj["value"] = obj["default_value"].split(";").join(" ")
            return obj
          },
        )
        state.deepDiveData = parameters
      }
    },
    newPipelineCellChange: (
      state,
      action: PayloadAction<INewTableCellChangePayload>,
    ) => {
      const temp = action.payload
      state.newPipeLine.userChangedTabs.push(state.newPipeLine.tabIndex)
      state.newPipeLine.activeData[temp.rowIndex][temp.keyName] = temp.value
      state.newPipeLine.tableData[state.newPipeLine.tabIndex] = [
        ...state.newPipeLine.activeData,
      ]
    },
    updateTabIndex: (state, action: PayloadAction<string>) => {
      state.newPipeLine.tabIndex = action.payload
      state.newPipeLine.activeData =
        state.newPipeLine.tableData[state.newPipeLine.tabIndex]
    },
    pipeLineFilterChange: (state, action: PayloadAction<string>) => {
      state.newPipeLine.filters.pipeline.selectedValue = action.payload
    },
    monitorUseCaseFilterChange: (state, action: PayloadAction<string>) => {
      state.newPipeLine.filters.useCase.selectedValue = action.payload
    },
    marketFilterChange: (state, action: PayloadAction<string>) => {
      state.newPipeLine.filters.market.selectedValue = action.payload
    },
    toggleNewPipeLineScreen: (state, action: PayloadAction<any>) => {
      state.newPipeLine.activeScreen = action.payload
    },
    toggleRunNow: (state, action: PayloadAction<any>) => {
      state.newPipeLine.runNow = action.payload
    },
    toggleScheduleNow: (state, action: PayloadAction<any>) => {
      state.newPipeLine.scheduleNow = action.payload
    },
    timeZoneChange: (state, action: PayloadAction<string>) => {
      state.newPipeLine.schedule.timeZone = action.payload
    },
    timeChange: (state, action: PayloadAction<string | null>) => {
      state.newPipeLine.schedule.time = action.payload
    },
    dateChange: (state, action: PayloadAction<any>) => {
      state.newPipeLine.schedule.date = action.payload
    },
    filterRefreshStatusCalendar: (
      state,
      action: PayloadAction<{ executionStatuCode: number; identifier: string }>,
    ) => {
      state.gantChartData = state.rawGantChartData.map((obj: any) => {
        const temp = { ...obj }
        if (temp && action.payload.identifier != "pipelines") {
          temp.data = temp.data.filter((run: ITask) => {
            return (
              run.status === action.payload.executionStatuCode ||
              run.status == undefined
            )
          })
        }
        return temp
      })
    },
    resetMonitorState: () => {
      return structuredClone(initialState)
    },
    setParameterData: (state, action: PayloadAction<any>) => {
      state.parameterConfigData = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(gantChartAsync.pending, (state) => {
        state.gantChartStatus = API_STATUS.LOADING
      })
      .addCase(gantChartAsync.fulfilled, (state, action: any) => {
        try {
          state.gantChartStatus = API_STATUS.IDLE
          let temp2 = reactGantTaskMapping(
            action.payload,
            state.monthSelectedValue,
            state.yearSelectedValue,
          )
          temp2 = temp2.concat(PIPELINE_RESPONSE_STATIC)
          state.gantChartData = temp2
          state.rawGantChartData = structuredClone(temp2)
        } catch (error) {
          state.gantChartStatus = API_STATUS.FAILED
        }
      })
      .addCase(gantChartAsync.rejected, (state) => {
        state.gantChartStatus = API_STATUS.FAILED
      })
      .addCase(flowDiagramAsync.pending, (state) => {
        state.flowDiagramStatus = API_STATUS.LOADING
      })
      .addCase(flowDiagramAsync.fulfilled, (state, action: any) => {
        try {
          state.flowDiagramStatus = API_STATUS.IDLE
          state.rawFlowDiagramData = action.payload
          const newData = state.rawFlowDiagramData[0]
          if (newData) {
            state.flowDiagramADFLink = newData["az_pipeline_run_url"]
            state.flowDiagramData = flowDiagramMapping([newData])
          } else {
            state.flowDiagramData = []
          }
        } catch (error) {
          state.flowDiagramStatus = API_STATUS.FAILED
        }
      })
      .addCase(flowDiagramAsync.rejected, (state) => {
        state.flowDiagramStatus = API_STATUS.FAILED
      })
      .addCase(lastRunAsync.pending, (state) => {
        state.lastRunStatus = API_STATUS.LOADING
      })
      .addCase(lastRunAsync.fulfilled, (state, action) => {
        try {
          state.lastRunStatus = API_STATUS.IDLE
          const lastRunDate = formatDate(action.payload.last_run)
          state.lastRunDate = lastRunDate // Update lastRunDate with the resul
        } catch (error) {
          state.lastRunStatus = API_STATUS.FAILED
        }
      })
      .addCase(lastRunAsync.rejected, (state) => {
        state.lastRunStatus = API_STATUS.FAILED
      })
      .addCase(pipelineCardsAsync.pending, (state) => {
        state.cardsStatus = API_STATUS.LOADING
      })
      .addCase(pipelineCardsAsync.fulfilled, (state, action) => {
        try {
          state.cardsStatus = API_STATUS.IDLE
          state.cards = commonPipeLineCardMapper(
            MONITOR_CARDS,
            action["payload"]["data"],
            action["payload"]["percentage_change"],
            action["payload"]["scheduled_pipelines"],
            action["payload"]["runs_data"],
          )
        } catch (error) {
          state.cardsStatus = API_STATUS.FAILED
        }
      })
      .addCase(pipelineCardsAsync.rejected, (state) => {
        state.cardsStatus = API_STATUS.FAILED
      })
      .addCase(refreshPipeLineAsync.pending, (state) => {
        state.refreshStatus = API_STATUS.LOADING
      })
      .addCase(refreshPipeLineAsync.fulfilled, (state) => {
        state.refreshStatus = API_STATUS.IDLE
      })
      .addCase(refreshPipeLineAsync.rejected, (state) => {
        state.refreshStatus = API_STATUS.FAILED
      })
      .addCase(deepDiveAsync.pending, (state) => {
        state.deepDiveDataStatus = API_STATUS.LOADING
      })
      .addCase(deepDiveAsync.fulfilled, (state, action: any) => {
        try {
          state.deepDiveDataStatus = API_STATUS.IDLE
          state.deepDiveRawData = action["payload"]
          state.deepDiveData = commonDeepDiveMapper(state, defaultPipelineData)
        } catch (error) {
          state.deepDiveDataStatus = API_STATUS.FAILED
        }
      })
      .addCase(deepDiveAsync.rejected, (state) => {
        state.deepDiveDataStatus = API_STATUS.FAILED
      })
      .addCase(newPipeLineBaseDataAsync.pending, (state) => {
        state.newPipeLine.status = API_STATUS.LOADING
      })
      .addCase(newPipeLineBaseDataAsync.fulfilled, (state, action: any) => {
        try {
          state.newPipeLine.status = API_STATUS.IDLE
          let tableData = JSON.parse(action["payload"]["data_csv"])

          tableData = pipelineConfigMapping(
            tableData,
            state.newPipeLine.tabIndex,
          )

          state.newPipeLine.tableData[state.newPipeLine.tabIndex] = tableData
          state.newPipeLine.activeData =
            state.newPipeLine.tableData[state.newPipeLine.tabIndex]
        } catch (error) {
          state.newPipeLine.status = API_STATUS.FAILED
        }
      })
      .addCase(newPipeLineBaseDataAsync.rejected, (state) => {
        state.newPipeLine.status = API_STATUS.FAILED
      })
      .addCase(newPipeLineUpdateBaseDataAsync.rejected, (state) => {
        state.newPipeLine.status = API_STATUS.FAILED
        state.alertStatus = setAlertData(
          ALERT_MSGS.PIPELINE.CONFIG_UPDATE_FAILED,
          ALERT_STATUS_MSGS.SUCCESS,
          true,
        )
      })
      .addCase(newPipeLineUpdateBaseDataAsync.pending, (state) => {
        state.newPipeLine.status = API_STATUS.LOADING
      })
      .addCase(newPipeLineUpdateBaseDataAsync.fulfilled, (state) => {
        try {
          state.newPipeLine.status = API_STATUS.IDLE
          state.alertStatus = setAlertData(
            ALERT_MSGS.PIPELINE.CONFIG_UPDATE_SUCCESS,
            ALERT_STATUS_MSGS.SUCCESS,
            true,
          )
        } catch (error) {
          state.newPipeLine.status = API_STATUS.FAILED
        }
      })
      .addCase(pipelineFilterOptionsAsync.pending, (state) => {
        state.newPipeLine.filters.pipeline.status = API_STATUS.LOADING
      })
      .addCase(pipelineFilterOptionsAsync.fulfilled, (state, action: any) => {
        try {
          state.newPipeLine.filters.pipeline.status = API_STATUS.IDLE
          state.newPipeLine.filters.pipeline.filterOptions = action["payload"][
            "data"
          ].map((obj: any) => {
            return {
              label: obj.pipeline_name,
              value: obj.pipeline_name,
              marketPlace: obj.market_place,
              useCase: obj.use_case,
            }
          })
        } catch (error) {
          state.newPipeLine.filters.pipeline.status = API_STATUS.FAILED
          console.error(error)
        }
      })
      .addCase(pipelineFilterOptionsAsync.rejected, (state) => {
        state.newPipeLine.filters.pipeline.status = API_STATUS.FAILED
      })
      .addCase(monitorUseCaseFilterOptionsAsync.pending, (state) => {
        state.newPipeLine.filters.useCase.status = API_STATUS.LOADING
      })
      .addCase(
        monitorUseCaseFilterOptionsAsync.fulfilled,
        (state, action: any) => {
          try {
            state.newPipeLine.filters.useCase.status = API_STATUS.IDLE
            const temp = action.payload.last_run.map((obj: any) => obj.name)
            state.newPipeLine.filters.useCase.filterOptions =
              CreateDropDownOptions(temp)
          } catch (error) {
            state.newPipeLine.filters.useCase.status = API_STATUS.FAILED
            console.error(error)
          }
        },
      )
      .addCase(monitorUseCaseFilterOptionsAsync.rejected, (state) => {
        state.newPipeLine.filters.useCase.status = API_STATUS.FAILED
      })

      .addCase(marketSingleFilterOptionsAsync.pending, (state) => {
        state.newPipeLine.filters.market.status = API_STATUS.LOADING
      })
      .addCase(
        marketSingleFilterOptionsAsync.fulfilled,
        (state, action: any) => {
          try {
            state.newPipeLine.filters.market.status = API_STATUS.IDLE
            const temp = action.payload.last_run.map((obj: any) => obj.name)
            state.newPipeLine.filters.market.filterOptions =
              CreateDropDownOptions(temp)
          } catch (error) {
            state.newPipeLine.filters.market.status = API_STATUS.FAILED
            console.error(error)
          }
        },
      )
      .addCase(marketSingleFilterOptionsAsync.rejected, (state) => {
        state.newPipeLine.filters.market.status = API_STATUS.FAILED
      })
      .addCase(runPipeLineAsync.rejected, (state) => {
        state.newPipeLine.runPipeLineStatus = API_STATUS.FAILED
        state.alertStatus = setAlertData(
          ALERT_MSGS.PIPELINE.EXECUTION_FAILED,
          ALERT_STATUS_MSGS.ERROR,
          true,
        )
      })
      .addCase(runPipeLineAsync.pending, (state) => {
        state.newPipeLine.runPipeLineStatus = API_STATUS.LOADING
      })
      .addCase(runPipeLineAsync.fulfilled, (state) => {
        try {
          state.newPipeLine.runPipeLineStatus = API_STATUS.IDLE
          state.alertStatus = setAlertData(
            ALERT_MSGS.PIPELINE.EXECUTION_STARTEDD,
            ALERT_STATUS_MSGS.SUCCESS,
            true,
          )
          state.isModalOpen = false
        } catch (error) {
          state.newPipeLine.runPipeLineStatus = API_STATUS.FAILED
        }
      })
      .addCase(schedulePipeLineAsync.rejected, (state) => {
        state.newPipeLine.scheduelPipeLineStatus = API_STATUS.FAILED
        state.alertStatus = setAlertData(
          ALERT_MSGS.PIPELINE.SCHEDULE_FAILED,
          ALERT_STATUS_MSGS.ERROR,
          true,
        )
      })
      .addCase(schedulePipeLineAsync.pending, (state) => {
        state.newPipeLine.scheduelPipeLineStatus = API_STATUS.LOADING
      })
      .addCase(schedulePipeLineAsync.fulfilled, (state) => {
        try {
          state.newPipeLine.scheduelPipeLineStatus = API_STATUS.IDLE
          state.alertStatus = setAlertData(
            ALERT_MSGS.PIPELINE.SCHEDULE_SUCCESS,
            ALERT_STATUS_MSGS.SUCCESS,
            true,
          )
          state.isModalOpen = false
        } catch (error) {
          state.newPipeLine.scheduelPipeLineStatus = API_STATUS.FAILED
          state.alertStatus = setAlertData(
            ALERT_MSGS.PIPELINE.SCHEDULE_FAILED,
            ALERT_STATUS_MSGS.ERROR,
            true,
          )
        }
      })
  },
})

export function formatDate(date: any): string {
  const parsedDate = parseISO(date)
  const formattedDate = format(parsedDate, "MM/dd/yyyy, hh:mm a")
  return formattedDate
}
function countByExecutionStatus(array: IWorkflow[], status: number) {
  const count = array.reduce((accumulator, obj) => {
    if (obj.last_run && obj.last_run.execution_status === status) {
      return accumulator + 1
    }
    return accumulator
  }, 0)

  return count
}
export const rawFlowDiagramDataSelector = (state: RootState) =>
  state.monitor.rawFlowDiagramData
export const flowDiagramDataSelector = (state: RootState) =>
  state.monitor.flowDiagramData
export const parentNodeDataSelector = (state: RootState) =>
  state.monitor.selectedParentNode

export const deepActiveScreenSelecter = (state: RootState) =>
  state.monitor.deepDiveActiveScreen
export const deepDiveDataSelector = (state: RootState) =>
  state.monitor.deepDiveData
export const deepDiveStatusSelector = (state: RootState) =>
  state.monitor.deepDiveDataStatus

export const flowDiagramStatusSelector = (state: RootState) =>
  state.monitor.flowDiagramStatus
export const gantActiveSelector = (state: RootState) =>
  state.monitor.activeGantSelection
export const refreshStatusSelector = (state: RootState) =>
  state.monitor.refreshStatus
export const clusterRadioBoxSelector = (state: RootState) =>
  state.monitor.activeClusterOption
export const gantChartStatusSelector = (state: RootState) =>
  state.monitor.gantChartStatus
export const lastRunStatusSelector = (state: RootState) =>
  state.monitor.lastRunStatus
export const cardsStatusSelector = (state: RootState) =>
  state.monitor.cardsStatus
export const clusterMemoryStatusSelector = (state: RootState) =>
  state.monitor.clusterMemoryChartStatus
export const clusterMemoryDataSelector = (state: RootState) =>
  state.monitor.clusterMemoryChartData
export const cardsSelector = (state: RootState) => state.monitor.cards
export const statusSelector = (state: RootState) => state.monitor.status
export const lastRunDateSelector = (state: RootState) =>
  state.monitor.lastRunDate
export const modelOpenSelector = (state: RootState) => state.monitor.isModalOpen
export const gantChartDataSelector = (state: RootState) =>
  state.monitor.gantChartData

export const gantSelectionLabelSelector = (state: RootState) =>
  state.monitor.activeGantSelectionLabel
export const activeTabSelector = (state: RootState) =>
  state.monitor.newPipeLine.tabIndex

export const usageMonitoringLabelsSelector = (state: RootState) =>
  state.monitor.usageMonitoringLabels

export const newPipeLineActiveDataSelector = (state: RootState) =>
  state.monitor.newPipeLine.activeData
export const flowDiagramADFLinkSelector = (state: RootState) =>
  state.monitor.flowDiagramADFLink

export const PipelineRunIsOpenSelector = (state: RootState) =>
  state.monitor.pipelineRunDialog.isOpen

export const PipelineRunDataSelector = (state: RootState) =>
  state.monitor.pipelineRunDialog.data
export const selectedRunDetailsSelector = (state: RootState) =>
  state.monitor.pipelineRunDialog.selectedRunDetails
export const getParameterData = (state: RootState) =>
  state.monitor.parameterConfigData

export const {
  openDialog,
  closeDialog,
  clusterOptionOnChange,
  gantSelectionChange,
  setFlowDiagramData,
  setParentNode,
  updateFlowDiagram,
  deepDiveScreenChange,
  updateGantSelectionLabel,
  updateTabIndex,
  newPipelineCellChange,
  openPipeLineRunDialog,
  closePipeLineRunDialog,
  setPipeLineRunDialogData,
  setRunDetails,
  pipeLineFilterChange,
  monitorUseCaseFilterChange,
  marketFilterChange,
  toggleNewPipeLineScreen,
  toggleRunNow,
  toggleScheduleNow,
  timeChange,
  timeZoneChange,
  dateChange,
  setAlertData2,
  cardToggle,
  monthFilterChangeMonitor,
  yearFilterChangeMonitor,
  filterRefreshStatusCalendar,
  updateRefreshStatus,
  resetMonitorState,
  setParameterData,
} = monitorSlice.actions

export default monitorSlice.reducer

export const flowDiagramMapping = (existingStruc: any) => {
  let temp: any = []
  existingStruc.map((obj: any) => {
    if (obj.workflow_graph) {
      temp = [...obj.workflow_graph]
    }
  })

  return temp
}

export const setAlertData = (
  msg: string,
  status: AlertColor,
  open: boolean,
) => {
  return {
    msg,
    status,
    open,
  }
}

function createTask(run: any, resource: any) {
  let backgroundColor
  let name
  if (run.execution_status == 0 || run.execution_status) {
    backgroundColor = colorMapperGant[run.execution_status]
    name = textMapperGant[run.execution_status]
  } else {
    backgroundColor = colorMapperGant[PipelineStatusCodes.SCHEDULED]
    name = textMapperGant[PipelineStatusCodes.SCHEDULED]
  }
  return {
    start: run.start_time,
    end: run.end_time,
    name: "",
    toolTipName: name,
    id: run.az_pipeline_run_id ? run.az_pipeline_run_id : uuidv4(),
    scheduled: !run.az_pipeline_run_id,
    type: "task",
    progress: 0,
    project: resource.name,
    isDisabled: true,
    styles: {
      backgroundColor,
    },
    status: run.execution_status,
  }
}

function createProjectResource(
  resource: any,
  selectedMonth: string,
  selectedYear: string,
) {
  const start = new Date(
    Number(selectedYear),
    MONTHS.indexOf(selectedMonth),
    1,
  ).toISOString()

  const end = new Date(
    Number(selectedYear),
    MONTHS.indexOf(selectedMonth),
    1,
  ).toISOString()

  return {
    start: start,
    end: end,
    name: "",
    id: resource.name,
    progress: 0,
    type: "project",
    showToolTip: resource.runs.length ? false : true,
    hideChildren: false,
    isDisabled: true,
  }
}

function mapResource(
  resource: any,
  selectedMonth: string,
  selectedYear: string,
) {
  const resourceData = resource.runs.map((run: any) =>
    createTask(run, resource),
  )

  const projectResource = createProjectResource(
    resource,
    selectedMonth,
    selectedYear,
  )

  return {
    name: resource.use_case.name + " " + resource.market_place.name,
    data: [projectResource, ...resourceData],
    extra: resource,
  }
}

function reactGantTaskMapping(
  existing: any,
  selectedMonth: string,
  selectedYear: string,
) {
  return existing.data.map((resource: any) =>
    mapResource(resource, selectedMonth, selectedYear),
  )
}

function commonDeepDiveMapper(state: any, screenArr: IPipelineData[]) {
  const temp = screenArr.map((obj: IPipelineData) => {
    let newObj: any = {}
    newObj = {
      ...obj,
    }
    try {
      const deepDiveRawData = state.deepDiveRawData
      const parameters: any = {}
      deepDiveRawData?.data?.["parameters"].map((o: IParameter) => {
        parameters[o["name"] as keyof IParameter] = o["default_value"]
      })
      switch (obj.key) {
        case "name":
          newObj["value"] = deepDiveRawData?.data?.name
          break

        case "market_place":
          newObj["value"] = deepDiveRawData?.data?.market_place?.name
          break

        case "progress": {
          newObj["value"] = deepDiveRawData?.data?.last_run?.progress
            ? deepDiveRawData?.data?.last_run?.progress + "%"
            : ""
          newObj["percentage"] = deepDiveRawData?.data?.last_run?.progress
          break
        }
        case "current_stage":
          newObj["value"] = deepDiveRawData?.data?.last_run?.current_stage
          break
        case "current_activity":
          newObj["value"] = deepDiveRawData?.data?.last_run?.current_activity
          break

        case "start_time": {
          const date = parseISO(deepDiveRawData?.data?.last_run?.start_time)
          const formattedDateTime = format(date, "dd/MM/yyyy, hh:mm:ss a")
          newObj["value"] = formattedDateTime
          break
        }
        case "end_time": {
          const endDate = parseISO(deepDiveRawData?.data?.last_run?.end_time)
          const endFormattedDateTime = format(endDate, "dd/MM/yyyy, hh:mm:ss a")
          newObj["value"] = endFormattedDateTime
          break
        }
        case "total_execution_time": {
          const difference = differenceInMilliseconds(
            new Date(deepDiveRawData?.data?.last_run?.end_time),
            new Date(deepDiveRawData?.data?.last_run?.start_time),
          )
          const duration = intervalToDuration({ start: 0, end: difference })

          const formattedDuration = formatDuration(duration, {
            delimiter: " ",
            zero: false,
          })

          newObj["value"] = formattedDuration
          break
        }

        case "last_activity_completed":
          newObj["value"] =
            deepDiveRawData?.data?.last_run?.last_activity_completed
          break

        case "pipeline_name":
          newObj["value"] = parameters["pipeline_name"]
          break

        case "create_adm_processed":
          newObj["value"] = parameters["create_adm_processed"]
          break

        case "cosine_similarity_new_output_required":
          newObj["value"] = parameters["cosine_similarity_new_output_required"]
          break

        case "input_series_recreate":
          newObj["value"] = parameters["input_series_recreate"]
          break

        case "results_to_be_changed_after_yearweek":
          newObj["value"] = parameters["results_to_be_changed_after_yearweek"]
          break

        case "input_series_version":
          newObj["value"] = parameters["input_series_version"]
          break
      }
    } catch (error) {
      console.error(error)
    }
    return newObj
  })
  return temp
}

function commonPipeLineCardMapper(
  arr: any,
  data: any,
  percentage_change: any,
  scheduled_pipelines: number,
  runs_data: any,
) {
  return arr.map((obj: IMonitorCardInterface) => {
    const temp: IMonitorCardInterface = { ...obj }
    if (obj.identifier === "pipelines") {
      temp["score"] = data.length
      temp["runs"] = runs_data.total_pipeline_runs
    } else if (obj.identifier === "scheduled") {
      temp["score"] = scheduled_pipelines
      temp["runs"] = runs_data.scheduled_pipeline_runs
    } else if (obj.identifier === "inProgress") {
      temp["score"] = countByExecutionStatus(data, PipelineStatusCodes.RUNNING)
      temp["runs"] = runs_data.running_pipeline_runs
    } else if (obj.identifier === "completed") {
      temp["score"] = countByExecutionStatus(data, PipelineStatusCodes.SUCCESS)
      temp["runs"] = runs_data.success_pipeline_runs
    } else if (obj.identifier === "failed") {
      temp["score"] = countByExecutionStatus(data, PipelineStatusCodes.FAILURE)
      temp["runs"] = runs_data.failure_pipeline_runs
    }
    if (obj.percentageKey) {
      temp.percentage = Number(
        Number(
          percentage_change[obj.percentageKey]["percentage_value"],
        ).toFixed(),
      )
      temp.decription =
        "vs " + percentage_change[obj.percentageKey]["time_period_label"]
    }
    return temp
  })
}
